{
    "customers_title": "العملاء",
    "customers_description": "المصدر الموحد لبيانات العملاء. كل شكوى ومكالمة وزيارة فرع ورد استبيان تعود إلى سجل هنا.",
    "customer": "العميل",
    "segment": "الشريحة",
    "status": "الحالة",
    "identity": "الهوية",
    "phone": "الهاتف",
    "branch": "الفرع",
    "activity": "آخر نشاط",
    "vip": "عميل مميز",
    "requires_assistance": "يحتاج مساعدة",
    "search_placeholder": "الاسم أو الرقم المرجعي أو الهاتف أو الرقم المدني…",
    "open_complaints_zero": "لا توجد شكاوى مفتوحة",
    "open_complaints_one": "شكوى مفتوحة واحدة",
    "open_complaints_two": "شكويان مفتوحتان",
    "open_complaints_few": "{{count}} شكاوى مفتوحة",
    "open_complaints_many": "{{count}} شكوى مفتوحة",
    "open_complaints_other": "{{count}} شكوى مفتوحة",
    "segments": {
        "micro": "متناهية الصغر",
        "sme": "صغيرة ومتوسطة",
        "corporate": "شركات كبرى",
        "retail": "أفراد"
    },
    "tabs": {
        "overview": "نظرة عامة",
        "timeline": "السجل الزمني",
        "products": "المنتجات",
        "relationships": "العلاقات",
        "consents": "الموافقات",
        "duplicates": "سجلات مكررة محتملة"
    },
    "overview": {
        "identity": "الهوية وبيانات الاتصال",
        "preferences": "التفضيلات",
        "flags": "المؤشرات والمخاطر",
        "rollups": "النشاط",
        "no_products": "لا توجد منتجات أو تسهيلات مسجلة.",
        "no_relationships": "لا توجد علاقات مسجلة.",
        "no_consents": "لا توجد سجلات موافقة.",
        "masked_hint": "البيانات الحساسة مخفية. يُسجَّل كشف أي قيمة في سجل التدقيق."
    },
    "timeline": {
        "title": "السجل الزمني للتفاعلات",
        "description": "جميع التفاعلات عبر كل القنوات في تسلسل زمني واحد.",
        "empty": "لا توجد تفاعلات مسجلة بعد.",
        "all": "الكل",
        "add_note": "إضافة ملاحظة",
        "note_placeholder": "سجّل ملاحظة على هذا العميل…",
        "internal_only": "داخلي فقط",
        "duration": "المدة",
        "outcome": "النتيجة"
    },
    "products": {
        "reference": "الرقم المرجعي",
        "stage": "المرحلة",
        "approved": "المعتمد",
        "outstanding": "المتبقي",
        "arrears": "متأخرات",
        "disbursed_on": "تاريخ الصرف"
    },
    "relationships": {
        "financial": "ارتباط مالي",
        "ownership": "ملكية {{percent}}%"
    },
    "kyc": "اعرف عميلك",
    "preferred_channel": "القناة المفضلة",
    "preferred_language": "اللغة",
    "relationship_manager": "مدير العلاقة",
    "risk_rating": "تصنيف المخاطر",
    "unidentified_banner": "لم يتم تحديد هوية جهة الاتصال هذه بعد. أكّد الهوية لنسب السجل إليها.",
    "merged_banner": "تم دمج هذا السجل في سجل آخر. أنت تعرض السجل الباقي.",
    "duplicates": {
        "title": "سجلات مكررة محتملة",
        "description": "سجلات تتشارك وثيقة هوية أو وسيلة اتصال. لا يتم الدمج تلقائيًا — راجع كل زوج.",
        "confidence": "درجة الثقة",
        "merge": "دمج…",
        "empty": "لم يتم العثور على سجلات مكررة محتملة."
    },
    "events": {
        "title": "مستكشف أحداث النواة",
        "description": "الأحداث المتدفقة بين الوحدات، وما عالج كل حدث، وما إذا أخفق شيء.",
        "replay": "إعادة تشغيل",
        "replayed": "أُعيد تشغيله",
        "listeners": "المستمعون",
        "failed": "أخفق",
        "payload": "الحمولة",
        "correlated": "نفس الإجراء الأصلي",
        "no_listeners": "لا يوجد مستمعون — سُجّل لأغراض التتبع.",
        "empty": "لا توجد أحداث مسجلة بعد."
    },
    "compliance": {
        "title": "مصفوفة الامتثال للكراسة",
        "description": "تغطية المتطلبات، مستمدة من تعليقات ‎@rfp‎ في الشيفرة وليست معلنة يدويًا.",
        "show_me": "اعرض لي",
        "mandatory": "إلزامي",
        "essential": "أساسي",
        "desirable": "مرغوب",
        "implemented": "منفّذ",
        "planned": "مخطط",
        "milestone": "المرحلة",
        "outstanding_only": "غير المنفّذ فقط",
        "all_requirements": "جميع المتطلبات",
        "export": "تصدير CSV"
    },
    "consents": {
        "description": "تُسجَّل الموافقة لكل غرض ولكل قناة. الموافقة على رسائل الخدمة عبر الرسائل النصية ليست موافقة على التسويق عبر واتساب.",
        "caption": "الموافقات حسب الغرض والقناة",
        "purpose": "الغرض",
        "saved": "تم تحديث الموافقة.",
        "audit_note": "يُسجَّل كل تغيير في سجل التدقيق مع بيان من قام به ومتى. تُحفظ حالات السحب ولا تُحذف.",
        "purposes": {
            "service": "رسائل الخدمة",
            "marketing": "التسويق",
            "surveys": "الاستبيانات",
            "data_sharing": "مشاركة البيانات",
            "recording": "تسجيل المكالمات"
        },
        "state": {
            "granted": "تمت الموافقة",
            "withdrawn": "سُحبت الموافقة",
            "unknown": "غير مسجلة"
        }
    },
    "segments_page": {
        "title": "الشرائح",
        "description": "مجموعات من العملاء تُحدَّد بقواعد، وتُحتسب لحظياً بدلاً من تخزينها.",
        "empty_title": "لا توجد شرائح معرّفة",
        "empty_description": "الشريحة سؤال محفوظ عن قاعدة العملاء — تُجاب من جديد في كل مرة تُفتح فيها.",
        "built_in": "مدمجة",
        "inactive": "غير مفعّلة",
        "remove": "حذف الشريحة",
        "removed": "تم حذف الشريحة.",
        "match_all": "يجب تحقق جميع الشروط",
        "match_any": "يكفي تحقق أي شرط",
        "view_members": "عرض الأعضاء",
        "vocabulary_title": "ما يمكن للشريحة أن تسأل عنه",
        "vocabulary_note": "تقتصر الشرائح على هذه الحقول. والقائمة مأخوذة من محرك التقييم نفسه، فلا يمكن تعريف شريحة على حقل لا يستطيع الاستعلام عنه."
    },
    "import": {
        "title": "استيراد العملاء",
        "description": "تحميل سجلات العملاء من ملف CSV. افحص الملف أولاً — فالاستيراد إما كامل أو لا شيء.",
        "file_title": "الملف",
        "file_label": "ملف CSV",
        "check": "فحص الملف",
        "commit": "استيراد",
        "columns": "الأعمدة المعروفة، والمطلوبة منها مميّزة. بحد أقصى {{max}} صف لكل ملف.",
        "ready": "{{count}} من أصل {{total}} صف جاهزة للاستيراد.",
        "rejected": "{{count}} صفوف بها مشكلات. لن يُستورد أي شيء حتى تُصحَّح.",
        "imported": "تم استيراد {{count}} سجل عميل.",
        "missing_columns": "الملف تنقصه أعمدة مطلوبة: {{columns}}.",
        "errors_title": "المشكلات المكتشفة",
        "line": "السطر {{line}}",
        "duplicates_title": "تكرارات محتملة",
        "duplicates_note": "تبدو هذه الصفوف مطابقة لعملاء مسجلين بالفعل. تُتجاوَز بدل إنشاء نسخة ثانية.",
        "duplicate_of": "السطر {{line}} يطابق {{reference}} (نسبة الثقة {{percent}}٪)"
    }
}
